/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityHoneypotsResult } from './MonitEntityHoneypotsResult';
import {
    MonitEntityHoneypotsResultFromJSON,
    MonitEntityHoneypotsResultFromJSONTyped,
    MonitEntityHoneypotsResultToJSON,
} from './MonitEntityHoneypotsResult';

/**
 * 
 * @export
 * @interface MonitPaginatedEntityHoneypotsResponse
 */
export interface MonitPaginatedEntityHoneypotsResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityHoneypotsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityHoneypotsResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityHoneypotsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityHoneypotsResult>}
     * @memberof MonitPaginatedEntityHoneypotsResponse
     */
    results?: Array<MonitEntityHoneypotsResult>;
}

/**
 * Check if a given object implements the MonitPaginatedEntityHoneypotsResponse interface.
 */
export function instanceOfMonitPaginatedEntityHoneypotsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPaginatedEntityHoneypotsResponseFromJSON(json: any): MonitPaginatedEntityHoneypotsResponse {
    return MonitPaginatedEntityHoneypotsResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntityHoneypotsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntityHoneypotsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityHoneypotsResultFromJSON)),
    };
}

export function MonitPaginatedEntityHoneypotsResponseToJSON(value?: MonitPaginatedEntityHoneypotsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityHoneypotsResultToJSON)),
    };
}

